module.exports = __webpack_public_path__ + "static/Element56-ad69fa42ff94e41915e91d1e1d9760c2.png";